import { Lock } from 'lucide-react';
import { PasswordForm } from '../components/PasswordForm.tsx';
import './PasswordScreen.css';

/**
 * What meets somebody who has just signed in with a password an admin handed
 * them, before anything else does.
 *
 * It has no route, and that is what makes it inescapable: RequireAuth draws it
 * instead of the outlet, so every authenticated URL is this screen while the
 * flag is up, «назад» leads to the login screen and straight back here, and the
 * chat layout under it is never mounted — no socket, no chat list, nothing
 * behind it to glimpse.
 *
 * There is no way past it on purpose. An account whose password is on a sticky
 * note somewhere is exactly the account this exists for, and «позже» is how a
 * screen like this one ends up never being seen again.
 */
export function FirstPasswordScreen() {
  return (
    <div className="first-password-screen">
      <div className="first-password-card">
        <div className="first-password-badge">
          <Lock size={22} />
        </div>
        <h2 className="first-password-title">Придумайте пароль</h2>
        <p className="first-password-lead">
          Вы вошли с паролем, который выдал администратор. Замените его своим — без этого
          переписки не открываются.
        </p>

        <PasswordForm askCurrent={false} submitLabel="Сохранить и войти" />

        <div className="first-password-foot">Пропустить нельзя</div>
      </div>
    </div>
  );
}
